import React from 'react';

import {
  ActionPlaceholder,
  ActionPlaceholderWrapper,
  BenefitsPlaceholder,
  BenefitsPlaceholderWrapper,
  ContentWrapper,
  LabelPlaceholder,
  LabelPlaceholderWrapper,
  LogoPlaceholder,
  LogoPlaceholderWrapper,
  MainInfo,
  MoreActionPlaceholder,
  RatePlaceholder,
  Wrapper,
} from './ProductCardLoader.styles';

function ProductCardLoader() {
  return (
    <Wrapper>
      <LabelPlaceholderWrapper>
        <LabelPlaceholder />
      </LabelPlaceholderWrapper>

      <ContentWrapper>
        <MainInfo>
          <LogoPlaceholderWrapper>
            <LogoPlaceholder />

            <RatePlaceholder />
          </LogoPlaceholderWrapper>

          <BenefitsPlaceholderWrapper>
            <BenefitsPlaceholder />

            <BenefitsPlaceholder />
          </BenefitsPlaceholderWrapper>
        </MainInfo>

        <ActionPlaceholderWrapper>
          <ActionPlaceholder />

          <MoreActionPlaceholder />
        </ActionPlaceholderWrapper>
      </ContentWrapper>
    </Wrapper>
  );
}

export default ProductCardLoader;
